import React from 'react';
import { formatCurrency } from '@/modules/dashboard/utils/dashboard.helpers';
import '@/modules/dashboard/styles/DashboardLineChartTooltip.css';

export default function DashboardLineChartTooltip({ active, payload, label }) {
  if (!active || !payload || !payload.length) return null;

  const sortedPayload = [...payload].sort((a, b) => b.value - a.value);

  return (
    <div className="dashboard-line-chart-tooltip">
      <p className="dashboard-line-chart-tooltip__title">{label}</p>

      {sortedPayload.map((entry, index) => (
        <div key={index} className="dashboard-line-chart-tooltip__row">
          <div className="dashboard-line-chart-tooltip__left">
            <div
              className="dashboard-line-chart-tooltip__dot"
              style={{ backgroundColor: entry.color }}
            />
            <span className="dashboard-line-chart-tooltip__label">{entry.name}</span>
          </div>

          <span className="dashboard-line-chart-tooltip__value">
            {formatCurrency(entry.value)}
          </span>
        </div>
      ))}
    </div>
  );
}